import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as $ from 'jquery';
import { RegularComponent } from "app/admin/regular/regular.component";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Globals } from 'app/globals';
import { AdminService, QuestionDto } from 'app/services/admin/AdminService';


@Component({
  selector: 'app-new-regular-modal',
  templateUrl: './new-regular-modal.component.html',
  styleUrls: ['./new-regular-modal.component.scss']
})
export class NewRegularModalComponent implements OnInit {
    @ViewChild('newregular', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;
    parent: any;
    text: string = "";
    actionEdit: boolean = false;
    actionCreate: boolean = false;
    currentIndex: number;
    languages: string[] = [];
    localizations: any[] = [];
    questionId: number;
    type: number;
    action: string;
    levels: any[] = [1, 2, 3, 4, 5, 6, 7];
    negativelyKeyed: boolean = false;
    testQuestion: boolean = false;
    currentLevel: number;
    parentName: string = '';
    categories: any[] = [];
    category: number;

  @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    
  constructor
      (
          private _AdminService: AdminService,
          private toastr: ToastrService,
          private router: Router,
          private _Globals: Globals
      )
  {
  }

  ngOnInit() {
      this.getLanguages();
  }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
          console.log('languages', data.result);
          let result = data.result.Result;
          
          if (result <= -10) {
              //this.toastr.warning('Expired token please login again.', 'ELI');
              this.router.navigate(['/login']);
              this._Globals.deleteAllStorage();
              return;
          }

          let _data = JSON.parse(data.result.Data);
          this.languages = _data;
      });
    }

    getQuestionCategories() {
        this._AdminService.getQuestionCategories().subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.categories = _data;
                console.log('getQuestionCategories', _data);

                //setting the first option by default
                if (this.actionCreate) {
                    this.category = this.categories[0].Id;
                }
            }
        });
    }

    getQuestion() {
        this._AdminService.getQuestion(this.questionId).subscribe((_data: any) => {

          console.log('response_getQuestion', _data);
            if (this._Globals.validationToken(_data.result.Result)) {
                let data = JSON.parse(_data.result.Data);
                console.log('question', data);

                if (this.type == 4) {
                    this.category = data.Category;
                    //setting the first option by default
                    if (this.category == 0) {
                        this.category = this.categories[0].Id;
                    }
                }              
              
                this.currentLevel = data.Level;
                $("#levels").val(data.Level);
                this.negativelyKeyed = data.NegativelyKeyed;
                if (this.negativelyKeyed) {
                    $('#regCheckbox').prop('checked', true);
                }

                this.testQuestion = data.IsTestQuestion;
                if (this.testQuestion) {
                    $('#checkboxTest').prop('checked', true);
                }

                this.localizations = data.Localizations;
          } 

      })
  }

    show(text: string, parent: any, action, questionId, sectionType: number, boolGetAllQuestions: boolean): void {
        console.log('parent', parent);
        this.parentName = parent.sectionName;

        this._Globals.boolGetAllQuestions = boolGetAllQuestions;

          $('#levels option').eq(0).prop('selected', true);
          $('#regCheckbox').prop('checked', false); // Unchecks it

        this.type = sectionType;

          $('textarea').val(text);
          this.text = text;
          this.parent = parent;
          this.questionId = questionId;
          this.action = action;
          switch (action) {
              case "edit":
                  this.actionEdit = true;
                  this.getQuestion();
                  break;
              case "create":
                  this.actionCreate = true;
                  break;
        }
        if (this.type == 4) {
            this.getQuestionCategories();
        }

          this.modal.show();
    }

    onShown(): void {
    }

  close(): void {
      this.modal.hide();
      this.resetActions();
      this.negativelyKeyed = false;
      this.testQuestion = false;
  }

  resetActions() {
      this.actionCreate = false;
      this.actionEdit = false;
      $('#languages').prop('selectedIndex', 0);
  }

  changeNegativelyKeyedStatus() {
      this.negativelyKeyed = !this.negativelyKeyed;
      console.log(this.negativelyKeyed);
    }

    changeTestQuestionStatus() {
        this.testQuestion = !this.testQuestion;
        console.log(this.testQuestion);
    }

  saveQuestion(text:string) {
      if (text == '') {
          this.toastr.warning('Field empty','ELI');
            return;
        }
      
      let questionId = 0;
      if (!this.actionCreate) {
          questionId = this.questionId;
      }

      let negativelyKeyed = 0;
      if (this.negativelyKeyed) {
          negativelyKeyed = 1;
      }

      let testQuestion = 0;
      if (this.testQuestion) {
          testQuestion = 1;
      }

      let questionDto = new QuestionDto();
      questionDto.Id = questionId;
      questionDto.Type = this.type;
      questionDto.Levels = parseInt($('#levels').val().toString());
      questionDto.NegativelyKeyed = negativelyKeyed;
      questionDto.IsTestQuestion = testQuestion;
      questionDto.Localizations = this.localizations;
      if (this.type == 4) { // 360
        questionDto.Category = this.category;
      } else {
         questionDto.Category = 0;
      }

      this._AdminService.postSaveQuestion(questionDto).subscribe(data => {
          console.log('postSaveQuestion response', data);
          if (data.result.Result != 0) {
              this.toastr.success('Edited successfully.', 'ELI');
              if (this._Globals.boolGetAllQuestions) {
                  this.parent.getAllQuestions();
              } else {
                  console.log("TYPE", this.type);
                  let gridApi;
                  if (this.type == 1) {
                      gridApi = this.parent.regularGridApi;
                  } else {
                      gridApi = this.parent.section1GridApi;
                  }
                  this.parent.updateRowEntry(gridApi, this.parent.currentRowIndex, this.localizations[0].Text, this.testQuestion);
              }              
              this.close();
          }
          else {
              this.toastr.error('Error. Please try again.', 'ELI');
          }
          //this.modalSave.emit();
      });
      //this.questionEmpty(text);
      //this.parent.insertNewRow(text);
      //this.modalSave.emit();
  }

  questionEmpty(text) {
      if (text == "") {
          $('#textarea').addClass('empty');
          setTimeout(function () {
              $('#textarea').removeClass('empty');
          }, 500);
          return;
      }
  }

  addLocalization(text: string, languageShortCode: string)
  {
      if (text != '')
      {
          console.log('setLocalization');
          if (this.localizations.length == 0) {
              this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
          }
          else {

              let arrayLength = this.localizations.length;
              let addNew = true;
              for (var i = 0; i < arrayLength; i++) {
                  if (this.localizations[i].LanguageShortCode == languageShortCode) {
                      //property exist
                      addNew = false;
                      this.localizations[i].Text = text;
                  }
              }
              if (addNew) {
                  //property not exist
                  this.localizations.push({ "LanguageShortCode": languageShortCode, "Text": text });
              }
          }
          console.log(this.localizations); 
      }   
  }

  clearTextArea() {
      $('#textarea').val('');
  }

  checkData(languageShortCode: string) {
      this.clearTextArea();
      console.log('check data', this.localizations);

      //check array for display data in text area if exist
      let arrayLength = this.localizations.length;
      for (var i = 0; i < arrayLength; i++) {
          if (languageShortCode == this.localizations[i].LanguageShortCode) {
              //property exist
              let text = this.localizations[i].Text;
              $('#textarea').val(text);
          }
      }
      
  }

  preventSpace(value: string, event: any) {
      if (value == null || value == "") {
          if (event.keyCode == 32) {
              return false;
          }
      }
      if (value == " ") {
          $('#textarea').val('');
      }
  }

}

interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
